import React from 'react';
import ReactDOM from 'react-dom/client';
import HomePage from './HomePage';
import { BrowserRouter, Routes,Route } from 'react-router-dom';
import AdminApp from './admin/AdminApp';
import './styles/GlobalStyles.css';
import './styles/Header.css';
import './styles/BanerPhoto.css';
import './styles/Calendar.css';
import './styles/AddressForm.css';
import './styles/HourSelector.css';
import './styles/CredentialsForm.css';
import './styles/ConfirmationForm.css';
import './styles/ReservationConfirmed.css';
import './styles/OfferSection.css';
import './styles/Footer.css';
import './styles/GoogleMaps.css';
import './styles/FormNavigator.css';
import './styles/PointsExchange.css';
import './styles/Calculator.css'
import './styles/ContactForm.css'
import "./styles/ContactTeaser.css"
import "./styles/ProductsPage.css";
import Layout from './layouts/Layout';
import ContactPage from './pages/Contact/ContactPage';
import ProductsPage from './pages/Products/ProductsPage';
import ReservationPage from './pages/Reservation.jsx/ReservationPage';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path='/produkty' element={<ProductsPage />}></Route>
          <Route path='/rezerwacja' element={<ReservationPage />}/>
        </Route>

        <Route path="/admint1efbau" element={<AdminApp />} />

        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);




